import { useState, useEffect } from 'react'

export const useResponsive = () => {
  const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0)

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return {
    width,
    isMobile: width < 640,
    isTablet: width >= 640 && width < 1024,
    isDesktop: width >= 1024,
    isUltraWide: width >= 1920,
    breakpoint: 
      width < 240 ? '3xs' :
      width < 320 ? '2xs' :
      width < 480 ? 'xs' :
      width < 640 ? 'sm' :
      width < 768 ? 'md' :
      width < 1024 ? 'lg' :
      width < 1280 ? 'xl' :
      '2xl'
  }
}